<template>
  <DsfFormControlBox class="ds-select" :owner="_self">
    <template #simple>
      <DsfTextProxy v-model="value" v-bind="_self.$props"></DsfTextProxy>
      <slot name="error">
        <div v-if="errors.length > 0" class="ds-error-text">
          {{ errorsMsg }}
        </div>
      </slot>
    </template>
    <template #content>
      <el-select ref="select" v-if="!readOnly" v-model="selectValue" :disabled="disabled" :placeholder="placeholder" :collapse-tags="collapseTags" :popper-class="dsf.isString(popperClass)?popperClass:''" :multiple-limit="multipleLimit" :multiple="multiple" :filterable="filterable || allowCreate" :filter-method="filter" :allow-create="allowCreate" :class="{ 'ds-error-border': errors.length > 0 }" :loading="loading" :default-first-option="allowCreate&&multiple" @visible-change="dropDownShow" @change="selectChange" @focus="isFocus = true">
        <el-option label="" value="" v-show="showSelectItem" :show=" !searchKey">
          <span style="color: #c0c0c0">请选择</span>
        </el-option>
        <el-option v-if="multiple && showSelectAll" label="全选" value="__selectAll">
          <div style="width: 100%" @click.stop="selectAll">
            <span style="font-weight: bold">{{ isSelectAll ? '取消全选' : '全选' }}</span>
          </div>
        </el-option>
        <template v-if="isDesign">
          <el-option label="数据1" value="1"></el-option>
          <el-option label="数据2" value="2"></el-option>
          <el-option label="数据3" value="3"></el-option>
          <el-option label="数据4" value="4"></el-option>
          <el-option label="数据5" value="5"></el-option>
        </template>
        <template v-else-if="isFocus">
          <select-item v-for="option in realItems" :show="optionVisable(option)" :key="option[valueField]" :item="option" />
        </template>
        <!-- 此处是为了防止 当isFocus为false时，选项没有加载而value有数据时能正常显示 start-->
        <template v-else-if="multiple && value">
          <el-option v-for="option in value" :show="optionVisable(option)" :key="option.value" :label="_formatSelectedText(option)">
            {{_formatOptionText(option)}}
          </el-option>
        </template>
        <template v-else-if="!multiple && value && value.value && value.text">
          <el-option :label="_formatSelectedText(value)" :value="value.value">
            {{_formatOptionText(value)}}
          </el-option>
        </template>
        <!-- 此处是为了防止 当isFocus为false时，选项没有加载而value有数据时能正常显示 end-->
      </el-select>
      <!--只读状态只显示div-->
      <div v-else-if="readOnly" class="ds-form-readonly">
        <DsfTextProxy v-model="value" v-bind="_self.$props" :show-label="false"></DsfTextProxy>
      </div>
      <slot name="error">
        <div v-if="errors.length > 0" class="ds-error-text">
          {{ errorsMsg }}
        </div>
      </slot>
    </template>
  </DsfFormControlBox>
</template>

<script>
const selectItem = Vue.defineLazyComponent(() => require("./selectItem.js"));

export default dsf.component({
  name: "DsfSelect",
  mixins: [$mixins.formControl, $mixins.itemsMixins],
  components: {
    selectItem
  },
  ctrlCaption: "下拉框",
  props: {
    simple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    filterable: {
      type: Boolean,
      default: false,
      desc: "是否可搜索"
    },
    filterByValue: {
      type: Boolean,
      default: false,
      desc: "是否支持value搜索"
    },
    multiple: {
      type: Boolean,
      default: false,
      desc: "是否多选"
    },
    allowCreate: {
      type: Boolean,
      default: false,
      desc: "是否可创建条目"
    },
    maxChooseNum: {
      type: Number,
      default: 0,
      desc: "多选时，选择上限，0为不限制"
    },
    collapseTags: {
      type: Boolean,
      default: false,
      desc: "多选时，选中值是否以合并展示"
    },
    optionRenderTime: {
      type: Number,
      default: 0,
      desc: "选项渲染时间"
    },
    loading: {
      type: Boolean,
      default: false
    },
    formatOptionText: {
      type: Function,
      required: false
    },
    // 是否显示全选按钮
    showSelectAll: {
      type: Boolean,
      default: false
    },
    // 是否显示空选项
    showSelectItem: {
      type: Boolean,
      default: true
    },
    popperClass: {
      type: [String, Boolean],
      default: ""
    }
  },
  data() {
    return {
      isFocus: false,
      searchKey: "",
      filterResult: [],
      showOptions: {},
      customerItems: []
    };
  },
  computed: {
    multipleLimit() {
      return this.maxChooseNum > 0 ? this.maxChooseNum : 0;
    },
    realItemsSize() {
      if (!this.multiple) return 0;
      let l = 0;
      dsf.deepForEach(
        this.realItems,
        () => {
          l++;
        },
        {
          isLast: true
        }
      );
      return l;
    },
    isSelectAll() {
      let limit = this.multipleLimit;
      let size = this.realItemsSize;
      let l = this.selectValue.length;
      if (!l) return false;
      if (!limit || limit >= size) {
        return l === size;
      }
      return l === limit;
    },
    realItems() {
      let cust = this.customerItems || [];
      let res = window.$mixins.itemsMixins.computed.realItems.call(this);
      if (this.allowCreate) {
        //如果存在自定义选项值
        if (cust) {
          _.each(cust, (it) => {
            dsf.array.ensure(res, it, (v) => {
              return v[this.valueField] == it[this.valueField];
            });
          });
          // res.push(...cust);
        }
      }
      return res;
    }
  },
  watch: {
    multiple(to, from) {
      if (!to && from) {
        this.selectValue = this.valueCopy.length ? this.valueCopy[0] : [];
      }
    }
  },
  created() {
    if (this.optionRenderTime === 0) {
      this.isFocus = true;
    }
  },
  methods: {
    focus() {
      this?.$refs?.select?.focus?.();
    },
    dropDownShow(evt) {
      if (evt) {
        this.searchKey = null;
        this.filterOptions();
      }
      this.$dispatch("visible-change", evt);
    },
    _formatOptionText(item) {
      if (this.formatOptionText) {
        return this.formatOptionText(item);
      }
      return item[this.optionsTextField];
    },
    _formatSelectedText(item) {
      return item[this.selectedTextField];
    },
    filter(key) {
      this.searchKey = key;
      this.filterOptions();
    },
    filterOptions() {
      let searchKey = this.searchKey || "";
      this.showOptions = {};
      let filterResult = [];
      let select = this.$refs.select;
      if (searchKey) {
        _.each(this.realItems, (item) => {
          // let c = item.text?.indexOf(searchKey) > -1 || item.py?.indexOf(searchKey) === 0 || item.pinyin?.indexOf(searchKey) === 0;
          let c = false;
          if (this.filterByValue) {
            c = item.text?.indexOf(searchKey) > -1 || item.py?.indexOf(searchKey) === 0 || item.pinyin?.indexOf(searchKey) === 0 || item.value?.indexOf(searchKey) === 0;
          } else {
            c = item.text?.indexOf(searchKey) > -1 || item.py?.indexOf(searchKey) === 0 || item.pinyin?.indexOf(searchKey) === 0;
          }
          this.$set(this.showOptions, item.value, c);
          if (c) {
            filterResult.push(c);
          }
        });
        select?.broadcast?.("ElOption", "queryChange", this.searchKey);
      } else {
        filterResult = this.realItems;
      }
      //这段代码注销了，这里不可以这样写，会导致动态添加选项出现问题
      //此处必须加入这段代码，否则如果检索无法匹配目标时不显示“未找到匹配项的文本”
      // if (select) {
      //   select.filteredOptionsCount = filterResult.length;
      // }
    },
    optionVisable(item) {
      return this.showOptions[item.value] !== false;
    },
    filterValue(value) {
      let reault = $mixins.itemsMixins.methods.filterValue.call(this, value);
      if (this.allowCreate) {
        let arr = [];
        _.each(value, (v) => {
          let obj;
          if (dsf.isObject(v)) {
            obj = v;
          } else {
            obj = _.find(reault, it => it[this.valueField] == v);
            if (!obj) {
              obj = { [this.textField]: v, [this.valueField]: v };
              if (this.postHasAlias) {
                obj[this.aliasField] = v;
              }
            }
          }
          arr.push(obj);
        });
        return arr;
      }
      return reault;
    },
    // 全选
    selectAll() {
      let values = [];
      if (!this.isSelectAll) {
        dsf.deepForEach(
          this.realItems,
          (it) => {
            values.push(it[this.valueField]);
          },
          {
            isLast: true
          }
        );
      }
      this.selectValue = values;
      this.selectChange();
    }
  }
});
</script>
